/* Ayudate · Estilos de las páginas independientes
   Calificar y Administración no cargan la hoja completa: solo lo justo. */

export const ESTILOS_MINIMOS = `
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600&family=Inter:wght@400;450;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap');
/* Los mismos tokens que estilos/global.js, uno por uno: las dos hojas son
   la misma identidad y los paneles no tienen por qué verse de otra época
   que el sitio público. Lo que cambió respecto de la versión anterior de
   este archivo es lo mismo que allá — degradados a color plano, sombras
   neutras en vez de teñidas de turquesa, radios 6/10/14 en vez de 999 px
   en todo, y --text-3 aclarado a #7C8B9C para pasar 4,5:1. */
.v2{--bg:#09090B;--bg-2:#0E0E11;--surface:#141417;--surface-2:#1A1A1E;--surface-3:#212126;
  --border:rgba(255,255,255,.09);--border-strong:rgba(255,255,255,.15);
  --border-accent:rgba(20,184,166,.42);--text-1:#F8FAFC;--text-2:#9AA9BA;--text-3:#7C8B9C;
  --text-inv:#04211F;--accent:#14B8A6;--accent-hi:#67E8F9;--accent-hover:#2DD4BF;
  --accent-deep:#0D9488;--accent-soft:rgba(20,184,166,.09);
  --accent-line:rgba(20,184,166,.28);--error:#F87171;
  /* --grad se queda con el nombre de siempre, pero ya no es un degradado:
     era el relleno de botones, chips y pastillas por toda la hoja y lo
     resuelve un color plano, así que renombrarlo en cuarenta reglas no
     cambiaría un pixel. */
  --grad:var(--accent);--grad-hover:var(--accent-hover);
  --glow-sm:0 1px 2px rgba(0,0,0,.5);
  --glow-md:0 10px 28px -14px rgba(0,0,0,.8);
  --glow-lg:0 28px 64px -24px rgba(0,0,0,.85);
  --r-sm:6px;--r-md:10px;--r-lg:14px;--r-pill:999px;
  --ease:cubic-bezier(.2,.6,.35,1);--ease-out:cubic-bezier(.23,1,.32,1);
  --t-rapido:.14s;--t-medio:.2s;
  --tr-superficie:background-color .14s var(--ease), border-color .14s var(--ease),
                  color .14s var(--ease);
  --mod-off:#000000;--mod-virt:#3B82F6;
  background:var(--bg);color:var(--text-1);min-height:100vh;
  font-family:'Inter',system-ui,sans-serif;line-height:1.6;
  -webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:rgba(20,184,166,.18);
  padding-left:env(safe-area-inset-left);padding-right:env(safe-area-inset-right);}
.v2 *{box-sizing:border-box;}
.v2 :focus-visible{outline:2px solid var(--accent-hi);outline-offset:2px;border-radius:3px;}
.v2 ::selection{background:rgba(20,184,166,.3);color:var(--text-1);}
.mono{font-family:'IBM Plex Mono',ui-monospace,monospace;font-variant-numeric:tabular-nums;}
.num{font-variant-numeric:tabular-nums;}
.mini-wrap{max-width:520px;margin:0 auto;padding:64px 22px;}
/* El logotipo es el mismo componente que en el sitio público (ver
   componentes/Marca.jsx): el isotipo y la palabra al lado, en un solo
   color. Las medidas y el porqué de cada una están en estilos/global.js,
   junto a la copia de estas mismas reglas — las dos hojas se cargan por
   separado (esta, en los paneles; aquella, solo en el sitio público), así
   que el logotipo tiene que quedar definido en ambas. Si cambian allá,
   cambian acá. */
.logo{display:inline-flex;align-items:baseline;gap:.256em;font-family:'Outfit',sans-serif;
  font-weight:600;font-size:20px;letter-spacing:-.01em;color:var(--text-1);}
.logo .iso{flex:0 0 auto;height:1.1em;width:auto;display:block;transform:translateY(.195em);}
.logo .marca{flex:0 0 auto;}
.mini-card{background:var(--surface);border:1px solid var(--border);border-radius:var(--r-lg);
  padding:32px;}
.mini-card h1{font-family:'Outfit',sans-serif;font-weight:400;font-size:27px;margin:0 0 12px;
  letter-spacing:-.032em;line-height:1.15;text-wrap:balance;}
.mini-card p{font-size:16px;color:var(--text-2);line-height:1.65;margin:0 0 18px;}
/* Las etiquetas de campo eran mono de 16 px en turquesa, del mismo tamaño
   que el texto que etiquetan. Ahora son lo que son: una referencia chica y
   apagada encima del campo. */
.lb{display:block;font-family:'IBM Plex Mono',monospace;font-size:11.5px;letter-spacing:.14em;
  text-transform:uppercase;color:var(--text-3);margin:20px 0 9px;}
.in{width:100%;padding:12px 14px;border-radius:var(--r-sm);border:1px solid var(--border);
  background:var(--bg-2);color:var(--text-1);font-family:'Inter',sans-serif;font-size:16px;}
.in.ta{resize:vertical;line-height:1.6;}
.in::placeholder{color:var(--text-3);}
.in:focus{border-color:var(--accent);outline:none;}
/* Aviso al pie de un campo (copiado de estilos/global.js): lo usa el modal
   de "agregar curso" del panel del tutor para decir que las materias de
   colegio no llevan nota ni comprobante. */
.privado{margin-top:16px;padding:12px 14px;border-radius:var(--r-sm);background:var(--bg-2);
  border:1px solid var(--border);border-left:2px solid var(--accent);
  font-size:15px;color:var(--text-2);line-height:1.55;}
.privado b{color:var(--text-1);}
.campo-pass{position:relative;}
.campo-pass .in{padding-right:44px;}
.pass-toggle{position:absolute;top:50%;right:6px;transform:translateY(-50%);width:32px;height:32px;
  display:flex;align-items:center;justify-content:center;background:none;border:none;padding:0;
  color:var(--text-3);cursor:pointer;border-radius:var(--r-sm);}
.pass-toggle:hover{color:var(--text-1);}
.pass-toggle svg{width:20px;height:20px;}
/* Centrado en los dos ejes, igual que en estilos/global.js: sin el
   justify-content, todo botón estirado (width:100%, flex:1) dejaba su texto
   contra el borde izquierdo, y sin el text-align una etiqueta partida en dos
   líneas quedaba desalineada consigo misma. */
.btn{font-family:'Inter',sans-serif;font-weight:500;font-size:15px;line-height:1;
  padding:12px 18px;border-radius:var(--r-sm);border:1px solid var(--border-strong);
  background:var(--surface);color:var(--text-1);cursor:pointer;text-decoration:none;
  display:inline-flex;align-items:center;justify-content:center;text-align:center;
  gap:7px;touch-action:manipulation;
  transition:var(--tr-superficie);}
.btn:hover{background:var(--surface-2);border-color:var(--border-accent);}
.btn:active{background:var(--surface-3);}
.btn-p{background:var(--accent);border-color:var(--accent);color:var(--text-inv);font-weight:600;}
.btn-p:hover{background:var(--accent-hover);border-color:var(--accent-hover);color:var(--text-inv);}
.btn-p:active{background:var(--accent-deep);border-color:var(--accent-deep);}
.btn-danger{border-color:rgba(248,113,113,.4);color:#FCA5A5;}
.btn-danger:hover{background:rgba(248,113,113,.1);border-color:rgba(248,113,113,.6);}
.btn:disabled{color:var(--text-3);background:var(--surface);border-color:var(--border);
  cursor:not-allowed;}
.estrellas{display:flex;gap:6px;}
.estrellas button{background:none;border:none;font-size:34px;line-height:1;cursor:pointer;
  color:var(--surface-3);padding:0 2px;transition:var(--tr-superficie);}
.estrellas button:hover,.estrellas button.on{color:#FBBF24;}
.sino2{display:flex;gap:8px;}
.sino2 button{flex:1;padding:11px;border-radius:var(--r-sm);border:1px solid var(--border);
  background:var(--bg-2);color:var(--text-2);font-size:16px;cursor:pointer;
  transition:var(--tr-superficie);}
.sino2 button:hover{border-color:var(--border-accent);color:var(--text-1);}
.sino2 button[aria-pressed="true"]{background:var(--accent);border-color:var(--accent);
  color:var(--text-inv);font-weight:600;}
.error{background:rgba(248,113,113,.09);border:1px solid rgba(248,113,113,.45);color:#FCA5A5;
  border-radius:var(--r-sm);padding:12px 14px;font-size:16px;margin-top:14px;}
.alerta-archivo{margin:0 0 14px;}
.tel-fila{display:flex;gap:8px;}
.tel-fila .tel-cod{flex:0 0 200px;padding-left:10px;padding-right:6px;overflow:hidden;
  text-overflow:ellipsis;white-space:nowrap;color-scheme:dark;}
.tel-fila .tel-cod option{background:var(--bg-2);color:var(--text-1);}
.tel-fila .tel-cod option:hover,.tel-fila .tel-cod option:focus,
.tel-fila .tel-cod option:checked{background:rgba(20,184,166,.10);color:var(--text-1);}
.tel-fila .tel-num{flex:1 1 auto;min-width:0;}
@media(max-width:480px){.tel-fila{flex-wrap:wrap;}.tel-fila .tel-cod{flex:1 1 100%;}}
.nota-correo{font-size:14px;margin-top:-10px;}
.exito{background:rgba(20,184,166,.09);border:1px solid rgba(20,184,166,.4);color:var(--accent-hi);
  border-radius:var(--r-sm);padding:12px 14px;font-size:16px;margin-top:14px;}

/* ---------- Dashboard del tutor ---------- */
/* Las cifras del panel, con el mismo tratamiento que las de la portada
   pública (.cifras en estilos/global.js): número grande y debajo su etiqueta
   y su nota al pie, sin caja, centrado todo dentro de su celda. El relleno
   es simétrico a propósito: con el 24px a la derecha y 0 a la izquierda que
   llevaba cuando el texto iba a la izquierda, el centro de la caja no cae
   donde el ojo espera y las cuatro cifras se ven corridas. */
.stats-row{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:0;
  margin-bottom:26px;border-top:1px solid var(--border-strong);}
.stat-card{background:none;border:0;border-right:1px solid var(--border);border-radius:0;
  padding:18px 14px;text-align:center;}
.stat-card:last-child{border-right:0;}
.stat-num{display:block;font-family:'Outfit',sans-serif;font-weight:400;font-size:30px;
  line-height:1;color:var(--text-1);letter-spacing:-.04em;font-variant-numeric:tabular-nums;}
.stat-lbl{display:block;font-size:14px;color:var(--text-2);margin-top:9px;line-height:1.4;}
.stat-sub{display:block;font-family:'IBM Plex Mono',monospace;font-size:11.5px;
  color:var(--text-3);margin-top:4px;line-height:1.45;font-variant-numeric:tabular-nums;}
@media(max-width:620px){
  .stats-row{grid-template-columns:1fr 1fr;}
  .stat-card{padding-left:10px;padding-right:10px;}
  .stat-card:nth-child(2n){border-right:0;}
}

/* Datos+Foto va en la columna izquierda, más ancha, para que su fila
   interna (carrera/año/email + foto) no se parta en dos. Disponibilidad y
   Seguridad son paneles de acción angostos (una etiqueta, un par de líneas
   y uno o dos botones), así que van apilados en la columna derecha, más
   angosta, dentro de .perfil-lateral. */
.perfil-filas{display:grid;grid-template-columns:1.8fr 1fr;
  gap:20px;margin-bottom:20px;align-items:start;}
@media (max-width:700px){.perfil-filas{grid-template-columns:1fr;}}
.perfil-panel{background:var(--bg-2);border:1px solid var(--border);border-radius:var(--r-md);
  padding:16px;display:flex;flex-direction:column;gap:12px;min-width:0;}
.perfil-lateral{display:flex;flex-direction:column;gap:20px;min-width:0;}
.perfil-unificado{display:flex;gap:24px;flex-wrap:wrap;padding:16px;
  background:var(--bg-2);border:1px solid var(--border);border-radius:var(--r-md);min-width:0;}
.perfil-datos{flex:1 1 200px;min-width:180px;display:flex;flex-direction:column;gap:14px;}
.perfil-foto{flex:1 1 240px;min-width:220px;display:flex;gap:16px;align-items:flex-start;}
.perfil-dato{display:flex;flex-direction:column;gap:3px;min-width:0;}
.perfil-dato-lbl{font-family:'IBM Plex Mono',monospace;font-size:12px;letter-spacing:.1em;
  text-transform:uppercase;color:var(--text-3);}
.perfil-dato-val{font-size:15px;color:var(--text-1);white-space:normal;word-break:break-word;
  overflow-wrap:anywhere;}
@media (max-width:560px){.perfil-unificado{flex-direction:column;}}

.fila-tarifa{margin:4px 0 0;font-size:14px;color:var(--text-2);}

/* ---------- Tarjetas de curso (Mis cursos): contenido arriba, acciones
   agrupadas en una barra al pie — separadas de la info para que 3 pills
   no queden apretadas contra el título en pantallas angostas. ---------- */
.cursos-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:16px;}

/* ---------- Grilla de tarjetas del panel admin ("Todos los tutores"):
   misma idea que .cursos-grid, con un mínimo más ancho para acomodar el
   detalle por curso (sesiones, calificación, tarifa) sin apretarse — a
   ~1600px de ancho (.dash-wrap-admin) da 3 columnas, como en la página
   pública de estudiantes (.grid en estilos/global.js), y se acomoda solo
   en pantallas más chicas. ---------- */
.tutores-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(420px,1fr));gap:18px;}
.curso-card{padding:20px;background:var(--surface);border:1px solid var(--border);
  border-radius:var(--r-md);transition:background-color var(--t-rapido) var(--ease),
  border-color var(--t-rapido) var(--ease);}
.curso-card:hover{background:var(--surface-2);border-color:var(--border-strong);}
.curso-card-titulo{display:flex;align-items:center;gap:10px;flex-wrap:wrap;}
.curso-card-titulo b{font-family:'Outfit',sans-serif;font-weight:500;font-size:17px;
  letter-spacing:-.02em;}
.curso-card-desc{margin:7px 0 0;font-size:14px;color:var(--text-2);line-height:1.55;}
.curso-card-tarifa{display:inline-flex;align-items:center;gap:4px;margin:12px 0 0;
  padding:5px 10px;border-radius:var(--r-sm);background:var(--bg-2);
  border:1px solid var(--border);font-family:'IBM Plex Mono',monospace;font-size:12.5px;
  color:var(--text-2);font-variant-numeric:tabular-nums;}
.curso-card-acciones{display:flex;align-items:center;justify-content:space-between;gap:10px 16px;
  flex-wrap:wrap;margin-top:14px;padding-top:14px;border-top:1px solid var(--border);}
.curso-card-acciones-sec{display:flex;gap:8px;flex-wrap:wrap;}
.btn-ghost{font-weight:500;font-size:13.5px;padding:9px 14px;border-radius:var(--r-sm);
  border:1px solid var(--border);background:transparent;color:var(--text-2);
  cursor:pointer;touch-action:manipulation;transition:var(--tr-superficie);}
.btn-ghost:hover{border-color:var(--border-accent);color:var(--text-1);background:var(--surface-2);}
.btn-ghost:disabled{opacity:.5;cursor:not-allowed;}
.btn-peligro-ghost{background:none;border:none;color:#FCA5A5;font-size:14px;font-weight:500;
  cursor:pointer;padding:9px 2px;text-decoration:underline;text-underline-offset:3px;
  text-decoration-color:transparent;transition:var(--tr-superficie);}
.btn-peligro-ghost:hover{text-decoration-color:#FCA5A5;}
.btn-peligro-ghost:disabled{opacity:.5;cursor:not-allowed;}

.historial-toggle{margin-top:14px;}
.historial-lista{margin-top:14px;padding-top:14px;border-top:1px solid var(--border);}
.historial-lista h3{font-family:'Outfit',sans-serif;font-weight:500;font-size:16px;margin:0 0 10px;}

.dash-topbar{position:fixed;top:0;left:0;right:0;z-index:60;background:var(--bg);
  border-bottom:1px solid var(--border);}
.dash-topbar-in{max-width:1240px;margin:0 auto;padding:0 22px;height:64px;
  display:flex;align-items:center;justify-content:space-between;gap:16px;}
.dash-topbar-in-admin{max-width:1600px;}
.dash-topbar-in .logo{white-space:nowrap;}
.dash-topbar-user{display:flex;align-items:center;gap:12px;flex-wrap:wrap;}
.dash-topbar-user span{font-size:14.5px;color:var(--text-2);}
.dash-wrap{max-width:1240px;padding-top:96px;}

/* Accesos rápidos del panel admin (Admin.jsx): NO va dentro de .dash-topbar
   (fixed, altura fija de 68px que .dash-wrap ya descuenta) — es su propio
   elemento sticky, empujado justo debajo del header con margin-top:68px y
   fijado ahí mismo al hacer scroll con top:68px. Como crece solo si los
   botones envuelven a una segunda línea en pantallas angostas, no hace
   falta ningún padding-top "mágico" en .dash-wrap-admin para compensarlo:
   por eso ese override de acá abajo es un valor chico, de aire visual nada
   más, no de compensación de altura. */
.dash-topbar-nav{position:sticky;top:64px;z-index:55;margin-top:64px;
  background:var(--bg-2);border-bottom:1px solid var(--border);}
.dash-topbar-nav-in{max-width:1600px;margin:0 auto;padding:10px 22px;
  display:flex;gap:4px;flex-wrap:wrap;}
.dash-topbar-nav-in a{display:inline-flex;align-items:center;gap:7px;font-weight:450;font-size:13.5px;
  padding:7px 12px;border-radius:var(--r-sm);border:1px solid transparent;
  background:transparent;color:var(--text-2);text-decoration:none;white-space:nowrap;
  cursor:pointer;touch-action:manipulation;transition:var(--tr-superficie);}
.dash-topbar-nav-in a:hover{color:var(--text-1);background:var(--surface);
  border-color:var(--border);}
.dash-topbar-badge{display:inline-flex;align-items:center;justify-content:center;min-width:17px;
  height:17px;padding:0 5px;border-radius:999px;background:var(--warning,#E0B15C);color:#1A1200;
  font-family:'IBM Plex Mono',monospace;font-size:11px;font-weight:500;line-height:1;
  font-variant-numeric:tabular-nums;}
.dash-wrap-admin{max-width:1600px;padding-top:26px;}
.dash-sec{margin-bottom:22px;}
.dash-sec h2{font-family:'Outfit',sans-serif;font-weight:500;font-size:19px;margin:0 0 14px;}
.dash-sec-finanzas{text-align:center;}
.dash-sec-finanzas .tabla-finanzas th,.dash-sec-finanzas .tabla-finanzas td{text-align:center;}
.chip{display:inline-block;font-family:'IBM Plex Mono',monospace;font-size:11.5px;font-weight:400;
  padding:3px 9px;border-radius:var(--r-sm);text-transform:uppercase;letter-spacing:.1em;}
.chip.on{background:rgba(20,184,166,.15);color:var(--accent-hi);}
.chip.off{background:rgba(148,163,184,.15);color:var(--text-2);}
.chip.warn{background:rgba(224,177,92,.16);color:var(--warning,#E0B15C);}
.chip.danger{background:rgba(248,113,113,.15);color:#FCA5A5;}
.chip.success{background:rgba(45,212,191,.16);color:var(--success,#2DD4BF);}

.pago-btn{font-weight:500;font-size:13px;padding:8px 14px;border-radius:var(--r-sm);
  cursor:pointer;touch-action:manipulation;transition:var(--tr-superficie);
  border:1px solid transparent;white-space:nowrap;}
.pago-btn:disabled{opacity:.6;cursor:not-allowed;}
.pago-btn.pendiente{background:var(--accent);color:var(--text-inv);border-color:var(--accent);
  font-weight:600;}
.pago-btn.pendiente:hover:not(:disabled){background:var(--accent-hover);
  border-color:var(--accent-hover);}
.pago-btn.pagado{background:rgba(45,212,191,.1);color:var(--success,#2DD4BF);
  border-color:rgba(45,212,191,.3);}
.pago-btn.pagado:hover:not(:disabled){background:rgba(45,212,191,.18);}

/* ---------- "Próxima sesión": tarjeta destacada con cuenta regresiva
   (tutor) / sala de espera (estudiante, ver SalaJitsi.jsx) ---------- */
.proxima-sesion{background:var(--accent-soft);
  border:1px solid var(--border-accent);border-radius:var(--r-md);padding:22px 24px;
  margin-bottom:22px;}
.proxima-sesion-eyebrow{font-family:'IBM Plex Mono',monospace;font-size:12px;letter-spacing:.14em;
  text-transform:uppercase;color:var(--accent);margin:0 0 8px;}
.proxima-sesion-curso{font-family:'Outfit',sans-serif;font-weight:500;font-size:21px;margin:0;
  letter-spacing:-.025em;}
.proxima-sesion-datos{margin:7px 0 0;font-size:15px;color:var(--text-2);}
.proxima-sesion-accion{margin-top:16px;}
.proxima-sesion-cuenta{display:inline-block;font-family:'IBM Plex Mono',monospace;font-size:14px;
  color:var(--accent-hi);font-variant-numeric:tabular-nums;}
.proxima-sesion-btn{font-size:15.5px;padding:13px 22px;}
.fila{display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;
  padding:16px 0;border-bottom:1px solid var(--border);}
.fila:last-child{border-bottom:none;}
.fila-info{min-width:0;flex:1;}
.fila-info b{font-size:16px;}
.fila-info p{margin:4px 0 0;font-size:14px;color:var(--text-2);}
.fila-acciones{display:flex;gap:8px;flex-wrap:wrap;}
.vacio{color:var(--text-3);font-size:15px;padding:8px 0;}

/* ---------- Modal (versión mínima de .ov/.mdl de estilos/global.js,
   para las páginas que no cargan la hoja completa) ---------- */
/* La capa aparece con opacidad y el diálogo con un scale(.97) — nunca
   desde scale(0). 200 ms con la curva de salida, igual que en el sitio
   público (ver .ov en estilos/global.js). */
.ov{position:fixed;inset:0;background:rgba(4,10,12,.82);backdrop-filter:blur(6px);
  z-index:90;overflow-y:auto;overscroll-behavior:contain;padding:24px 16px;
  animation:capa-entra var(--t-medio) var(--ease-out) both;}
@keyframes capa-entra{from{opacity:0;}to{opacity:1;}}
@keyframes dialogo-entra{from{opacity:0;transform:scale(.97);}to{opacity:1;transform:none;}}
.ov .mdl{animation:dialogo-entra var(--t-medio) var(--ease-out) both;transform-origin:center;}
.v2.sinmov .ov,.v2.sinmov .ov .mdl{animation:none;}
.ov-caja{min-height:100%;width:100%;display:flex;align-items:center;justify-content:center;}
.mdl{background:var(--surface);border:1px solid var(--border-strong);border-radius:var(--r-lg);
  width:100%;max-width:440px;}
.mdl.mdl-ancho{max-width:680px;}
.mdl-h{padding:22px 24px;border-bottom:1px solid var(--border);display:flex;gap:14px;
  align-items:flex-start;justify-content:space-between;}
.mdl-h h3{margin:0;font-family:'Outfit',sans-serif;font-weight:500;font-size:19px;}
.x{background:none;border:none;color:#FCA5A5;font-size:22px;line-height:1;cursor:pointer;}
.mdl-b{padding:22px 24px;}

/* ---------- Grilla de disponibilidad (copiada de estilos/global.js,
   para las páginas que no cargan la hoja completa) ---------- */
.notas{background:var(--bg-2);border:1px solid var(--border);border-left:2px solid var(--accent);
  border-radius:var(--r-sm);padding:14px 16px;margin-bottom:16px;}
.notas p{margin:0 0 7px;font-size:16px;color:var(--text-2);line-height:1.55;}
.notas p:last-child{margin-bottom:0;}
.notas b{color:var(--text-1);}
.gwrap{border:1px solid var(--border);border-radius:var(--r-md);background:var(--bg-2);
  padding:12px;}
.grid-h{display:grid;gap:3px;}
.gdd{font-family:'IBM Plex Mono',monospace;font-size:16px;letter-spacing:.08em;
  color:var(--text-3);text-align:center;padding-bottom:5px;}
.ghh{font-family:'IBM Plex Mono',monospace;font-size:16px;color:var(--text-3);
  display:flex;align-items:center;justify-content:flex-end;padding-right:7px;}
.gcell{position:relative;}
.gcel{width:100%;height:21px;border-radius:4px;border:1px solid var(--border);
  background:var(--mod-off);cursor:pointer;font-family:'IBM Plex Mono',monospace;
  font-size:16px;font-weight:600;color:var(--text-3);padding:0;
  transition:var(--tr-superficie);}
.gcel:hover{border-color:var(--mod-virt);}
.gcel.virtual{background:var(--mod-virt);border-color:var(--mod-virt);color:#061633;}
.gleg{display:flex;align-items:center;flex-wrap:wrap;
  gap:10px 14px;margin-top:11px;padding-top:10px;
  border-top:1px solid var(--border);font-size:16px;color:var(--text-3);}
.gleg .limpiar{margin-left:auto;}
.gleg-items{display:flex;flex-wrap:wrap;gap:14px;}
.gleg span{display:inline-flex;align-items:center;gap:6px;}
.gsw{width:11px;height:11px;border-radius:3px;display:inline-block;flex:0 0 auto;
  border:1px solid var(--border);}
.gsw.virtual{background:var(--mod-virt);border-color:var(--mod-virt);}
.gsw.vac{background:var(--mod-off);border-color:var(--border-strong);}
.displb{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:0 0 10px;}
.limpiar{background:none;border:none;color:var(--text-3);font-size:16px;cursor:pointer;
  text-decoration:underline;text-underline-offset:3px;padding:0;}
.limpiar:hover{color:#FCA5A5;}
.gdias{display:flex;gap:5px;overflow-x:auto;padding-bottom:10px;margin-bottom:12px;
  border-bottom:1px solid var(--border);scrollbar-width:none;}
.gdias::-webkit-scrollbar{display:none;}
.gdia{position:relative;flex:0 0 auto;min-width:52px;padding:11px 12px;border-radius:var(--r-sm);
  border:1px solid var(--border);background:var(--surface);color:var(--text-2);
  font-family:'IBM Plex Mono',monospace;font-size:16px;letter-spacing:.06em;cursor:pointer;}
.gdia.on{background:var(--accent);border-color:var(--accent);color:var(--text-inv);font-weight:600;}
.gdia i{position:absolute;top:-5px;right:-5px;min-width:17px;height:17px;padding:0 4px;
  border-radius:9px;background:var(--accent-hi);color:var(--text-inv);font-style:normal;
  font-size:16px;font-weight:700;display:grid;place-items:center;border:1px solid var(--surface);}
.ghoras{display:flex;flex-direction:column;gap:6px;}
.ghora{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;
  min-height:48px;padding:11px 15px;border-radius:var(--r-sm);border:1px solid var(--border);
  background:var(--mod-off);cursor:pointer;text-align:left;transition:var(--tr-superficie);}
.ghora:hover{border-color:var(--border-strong);}
.ghh2{font-family:'IBM Plex Mono',monospace;font-size:16px;color:var(--text-1);font-weight:500;}
.ghv{font-size:16px;color:var(--text-3);}
.ghora.virtual{background:var(--mod-virt);border-color:var(--mod-virt);}
.ghora.virtual .ghh2,.ghora.virtual .ghv{color:#061633;}

/* ---------- Ranking de tutores (panel de administración) ---------- */
.rank-tabla{width:100%;border-collapse:collapse;font-size:14px;}
.rank-tabla th{text-align:left;padding:9px 12px;border-bottom:1px solid var(--border);
  color:var(--text-3);font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:.08em;
  text-transform:uppercase;white-space:nowrap;}
.rank-tabla td{padding:12px;border-bottom:1px solid var(--border);vertical-align:middle;}
.rank-tabla tr:last-child td{border-bottom:none;}
.rank-tabla td.rank-pos{font-family:'IBM Plex Mono',monospace;color:var(--text-3);width:1%;
  white-space:nowrap;}
.rank-tabla td.rank-pos.top3{color:var(--accent-hi);font-weight:700;}
.rank-rating{color:#FFFFFF;}
.rank-rating b{color:#F59E0B;font-weight:600;}
/* Ranking de tutores: encabezados centrados sobre su columna de datos. */
.tabla-ranking th,.tabla-ranking td{text-align:center;}
.pag{display:flex;align-items:center;justify-content:center;gap:6px;flex-wrap:wrap;
  margin-top:18px;}
.pbtn{min-width:38px;height:38px;padding:0 11px;border-radius:var(--r-sm);
  border:1px solid var(--border);background:var(--surface);color:var(--text-2);
  font-family:'Inter',sans-serif;font-size:16px;cursor:pointer;transition:var(--tr-superficie);}
.pbtn:hover:not(:disabled){border-color:var(--accent);color:var(--text-1);
  background:var(--surface-2);}
.pbtn:disabled{opacity:.32;cursor:not-allowed;}
.pbtn.on{background:var(--accent);border-color:var(--accent);color:var(--text-inv);font-weight:600;}
.psalto{color:var(--text-3);padding:0 3px;font-size:16px;}
.chip-btn{border:none;font-family:inherit;cursor:pointer;transition:var(--tr-superficie);}
.chip-btn:disabled{opacity:.6;cursor:not-allowed;}
.chip-btn.off:hover:not(:disabled){background:rgba(148,163,184,.25);}
.chip-btn.on:hover:not(:disabled){background:rgba(20,184,166,.25);}
.tutor-link{border:none;background:none;padding:0;font:inherit;color:var(--text-1);
  font-weight:600;cursor:pointer;text-decoration:underline;text-underline-offset:3px;
  text-decoration-color:transparent;transition:var(--tr-superficie);}
.tutor-link:hover{text-decoration-color:var(--text-1);}

/* ---------- Foto de perfil (copiada de estilos/global.js) ---------- */
.opc{font-family:'Inter',sans-serif;letter-spacing:0;text-transform:none;color:var(--text-3);
  font-size:16px;}
.ayuda{font-size:16px;line-height:1.5;color:var(--text-3);margin:2px 0 16px;padding-left:2px;}
.ayuda.mal{color:#FCA5A5;font-weight:500;}
.ayuda.mal::before{content:"▲ ";font-size:16px;vertical-align:1px;}
.fotorow{display:flex;gap:16px;align-items:flex-start;margin-bottom:16px;}
.fotoprev{width:78px;height:78px;flex:0 0 auto;border-radius:var(--r-md);overflow:hidden;
  background:var(--bg-2);border:1px dashed var(--border-strong);color:var(--text-3);
  display:grid;place-items:center;}
.fotoprev img{width:100%;height:100%;object-fit:cover;}
.fotoprev svg{width:44%;height:44%;}
.fotoacc{flex:1;min-width:0;}
.fotobtn{display:inline-block;cursor:pointer;padding:9px 16px;font-size:16px;}
.fotobtn input{display:none;}
.fotobtn.ocupado{opacity:.6;pointer-events:none;}
.fotoquitar{background:none;border:none;color:var(--text-3);font-size:16px;cursor:pointer;
  text-decoration:underline;text-underline-offset:3px;margin-left:12px;}
.fotoquitar:hover{color:#FCA5A5;}

/* ---------- Accesibilidad (copiada de estilos/global.js, para las
   páginas que no cargan la hoja completa) ---------- */
.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;
  clip:rect(0 0 0 0);white-space:nowrap;border:0;}

.a11y-btn{position:fixed;right:20px;bottom:20px;z-index:120;width:52px;height:52px;
  border-radius:50%;border:1px solid var(--accent);background:var(--accent);
  color:var(--text-inv);cursor:pointer;display:grid;place-items:center;
  box-shadow:var(--glow-md);touch-action:manipulation;transition:var(--tr-superficie);}
.a11y-btn:hover{background:var(--accent-hover);border-color:var(--accent-hover);}
.a11y-btn svg{width:28px;height:28px;}
.a11y-badge{position:absolute;top:-3px;right:-3px;min-width:20px;height:20px;padding:0 5px;
  border-radius:10px;background:var(--surface);color:var(--accent-hi);font-size:16px;
  font-weight:700;display:grid;place-items:center;border:1px solid var(--border-accent);
  font-family:'IBM Plex Mono',monospace;}
@media(max-width:560px){.a11y-btn{right:14px;bottom:14px;width:48px;height:48px;}
  .a11y-btn svg{width:25px;height:25px;}}
@keyframes latir{0%,100%{box-shadow:0 0 0 0 rgba(20,184,166,.28);}50%{box-shadow:0 0 0 9px rgba(20,184,166,0);}}
.a11y-btn.llamando{animation:latir 2.4s ease-in-out infinite;}
.v2.sinmov .a11y-btn.llamando{animation:none;}

.a11y-tip{position:fixed;right:86px;bottom:22px;z-index:119;max-width:280px;
  background:var(--surface);border:1px solid var(--border-accent);border-radius:var(--r-md);
  padding:15px 17px;box-shadow:var(--glow-md);}
.a11y-tip b{display:block;font-size:16px;color:var(--text-1);margin-bottom:6px;}
.a11y-tip span{display:block;font-size:16px;color:var(--text-2);line-height:1.55;}
.a11y-tipx{margin-top:12px;background:none;border:none;padding:0;cursor:pointer;
  font-size:16px;color:var(--accent-hi);text-decoration:underline;text-underline-offset:3px;}
.a11y-tip::after{content:"";position:absolute;right:-7px;bottom:22px;width:12px;height:12px;
  background:var(--surface);border-right:1px solid var(--border-accent);
  border-top:1px solid var(--border-accent);transform:rotate(45deg);}
@media(max-width:700px){
  .a11y-tip{right:14px;left:14px;max-width:none;bottom:76px;}
  .a11y-tip::after{display:none;}
}

.a11y-panel{position:fixed;right:20px;bottom:86px;z-index:121;width:330px;
  max-height:calc(100vh - 120px);overflow-y:auto;background:var(--surface);
  border:1px solid var(--border-strong);border-radius:var(--r-lg);box-shadow:var(--glow-lg);}
@media(max-width:560px){.a11y-panel{right:10px;left:10px;width:auto;bottom:76px;}}
.a11y-h{display:flex;align-items:center;justify-content:space-between;padding:18px 20px 14px;
  border-bottom:1px solid var(--border);position:sticky;top:0;background:var(--surface);z-index:2;}
.a11y-h h4{font-family:'Outfit',sans-serif;font-weight:500;font-size:18px;margin:0;
  letter-spacing:-.02em;color:var(--text-1);}
.a11y-b{padding:16px 20px 20px;}
.a11y-grp{margin-bottom:20px;}
.a11y-lb{display:block;font-family:'IBM Plex Mono',monospace;font-size:11.5px;letter-spacing:.14em;
  text-transform:uppercase;color:var(--text-3);margin-bottom:10px;}
.a11y-nota{font-size:13.5px;color:var(--text-3);line-height:1.5;margin:9px 0 0;}

.a11y-seg{display:grid;grid-template-columns:repeat(4,1fr);gap:5px;}
.a11y-seg button{padding:9px 0;border-radius:var(--r-sm);border:1px solid var(--border);
  background:var(--bg-2);color:var(--text-2);font-family:'IBM Plex Mono',monospace;
  font-size:16px;cursor:pointer;transition:var(--tr-superficie);}
.a11y-seg button:hover{border-color:var(--border-accent);color:var(--text-1);}
.a11y-seg button[aria-pressed="true"]{background:var(--accent);border-color:var(--accent);
  color:var(--text-inv);font-weight:600;}

.a11y-list{display:flex;flex-direction:column;gap:5px;}
.a11y-op{text-align:left;padding:10px 13px;border-radius:var(--r-sm);
  border:1px solid var(--border);background:var(--bg-2);color:var(--text-2);cursor:pointer;
  transition:var(--tr-superficie);}
.a11y-op b{display:block;font-size:16px;color:var(--text-1);font-weight:600;}
.a11y-op span{display:block;font-size:16px;margin-top:2px;}
.a11y-op:hover{border-color:var(--border-accent);}
.a11y-op.on{background:var(--accent-soft);border-color:var(--accent);}
.a11y-op.on b{color:var(--accent-hi);}

.a11y-sw{display:flex;align-items:flex-start;gap:12px;width:100%;text-align:left;
  padding:11px 13px;border-radius:var(--r-sm);border:1px solid var(--border);
  background:var(--bg-2);cursor:pointer;margin-bottom:6px;transition:var(--tr-superficie);}
.a11y-sw:hover{border-color:var(--border-accent);}
.a11y-sw.on{background:var(--accent-soft);border-color:var(--accent);}
.a11y-swt{flex:0 0 auto;width:34px;height:19px;border-radius:10px;background:var(--surface-3);
  border:1px solid var(--border-strong);position:relative;margin-top:1px;
  transition:var(--tr-superficie);}
.a11y-swt i{position:absolute;top:2px;left:2px;width:13px;height:13px;border-radius:50%;
  background:var(--text-3);
  transition:transform var(--t-rapido) var(--ease-out),background-color var(--t-rapido) var(--ease);}
.a11y-sw.on .a11y-swt{background:var(--accent);border-color:var(--accent);}
.a11y-sw.on .a11y-swt i{transform:translateX(15px);background:var(--text-inv);}
.a11y-swl b{display:block;font-size:16px;color:var(--text-1);font-weight:600;}
.a11y-swl span{display:block;font-size:16px;color:var(--text-3);margin-top:2px;line-height:1.45;}

/* ---- Efectos de los ajustes ---- */
.v2.z70 .dash-wrap,.v2.z70 .mdl{zoom:.70;}
.v2.z80 .dash-wrap,.v2.z80 .mdl{zoom:.80;}
.v2.z90 .dash-wrap,.v2.z90 .mdl{zoom:.90;}
.v2.z110 .dash-wrap,.v2.z110 .mdl{zoom:1.10;}
.v2.z125 .dash-wrap,.v2.z125 .mdl{zoom:1.25;}
.v2.z150 .dash-wrap,.v2.z150 .mdl{zoom:1.50;}
.v2.z175 .dash-wrap,.v2.z175 .mdl{zoom:1.75;}

.v2.f-protanopia .dash-wrap,.v2.f-protanopia .ov{filter:url(#ay-protanopia);}
.v2.f-deuteranopia .dash-wrap,.v2.f-deuteranopia .ov{filter:url(#ay-deuteranopia);}
.v2.f-tritanopia .dash-wrap,.v2.f-tritanopia .ov{filter:url(#ay-tritanopia);}
.v2.f-grises .dash-wrap,.v2.f-grises .ov{filter:url(#ay-grises);}

.v2.fuente-legible,.v2.fuente-legible *{font-family:'Atkinson Hyperlegible','Inter',sans-serif !important;}

.v2.espaciado p,.v2.espaciado li{line-height:1.75 !important;letter-spacing:.06em !important;
  word-spacing:.16em !important;}
.v2.espaciado p{margin-bottom:1.6em !important;}

.v2.contraste{--text-1:#FFFFFF;--text-2:#E2E8F0;--text-3:#CBD5E1;
  --bg:#000000;--bg-2:#080A10;--surface:#101014;--surface-2:#16161C;--surface-3:#1E1E26;
  --border:rgba(255,255,255,.30);--border-strong:rgba(255,255,255,.48);
  --border-accent:rgba(103,232,249,.6);--accent:#2DD4BF;--accent-hi:#A5F3FC;}
.v2.contraste .a11y-nota{color:var(--text-2);}

.v2.enlaces a:not(.btn):not(.a11y-btn){text-decoration:underline !important;
  text-underline-offset:3px;text-decoration-thickness:2px;}

.v2.sinmov *,.v2.sinmov *::before,.v2.sinmov *::after{
  animation:none !important;transition:none !important;scroll-behavior:auto !important;}
.v2.sinmov .in.falta,.v2.sinmov .falta-bloque{animation:none;}

/* Movimiento reducido: se va el desplazamiento —el diálogo que escala, el
   interruptor que corre— y se quedan las transiciones de color, que son
   las que dicen si un botón respondió. */
@media(prefers-reduced-motion:reduce){
  .v2 .ov .mdl{animation:capa-entra var(--t-medio) var(--ease-out) both;}
  .v2 .a11y-sw.on .a11y-swt i{transform:none;left:17px;}
  .v2 .a11y-btn.llamando{animation:none;}
  .v2 *{scroll-behavior:auto !important;}
}
`;
